import type { TranslationKey } from '@/i18n/i18n';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterNavLink } from 'react-router';

import { useActiveRoute } from '../hooks/useActiveRoute';

interface NavLinkProps {
  text: TranslationKey;
  to: string | undefined;
  className?: string;
  isUtilitySection?: boolean;
}

export const NavLink = ({ text, to, className, isUtilitySection = false }: NavLinkProps) => {
  const { t } = useTranslation();
  const { isActive } = useActiveRoute(to);

  const shouldApplyActiveColor = isActive && !isUtilitySection;

  if (!to) {
    return (
      <div className="w-full">
        <div className="text-typography/65 flex h-10 w-full items-center justify-start rounded-sm py-2 pr-6 pl-12 text-sm transition-colors">
          {t(text)}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <RouterNavLink
        to={to}
        className={cn(
          'flex h-10 w-full cursor-pointer items-center justify-start rounded-none py-2 pr-4 pl-12 text-sm transition-colors',
          shouldApplyActiveColor ? 'text-primary-900' : 'text-typography/65',
          className
        )}
      >
        {t(text)}
      </RouterNavLink>
    </div>
  );
};
